import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { MessageDescriptorPropType } from '../../prop-types/intl';

import messages from './messages';

export const BulkApplyCheckbox = ({ isBulkUpdate, toggleBulkUpdate, message = messages.bulkUpdateCheckBoxMessage, disabled = false }) => {
  return (
    <Checkbox
      checked={isBulkUpdate}
      disabled={disabled}
      label={<FormattedMessage {...message} />}
      onChange={toggleBulkUpdate}
      tabIndex={0}
    />
  );
};

BulkApplyCheckbox.propTypes = {
  isBulkUpdate: PropTypes.bool.isRequired,
  toggleBulkUpdate: PropTypes.func.isRequired,
  message: MessageDescriptorPropType,
  disabled: PropTypes.bool,
};
